import { FirebaseTimestamp } from '@/models/hardware.model';

export type Client = {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  lastSession: string;
  email: string;
  gender: Gender;
  status: ClientStatus;
  orgId: string;
  therapistId: string;
  createdAt: string;
  totalSessions: number;
  id: string;
  role: string;
};

export type ExportedClient = {
  firstName: string;
  lastName: string;
  dateOfBirth: FirebaseTimestamp;
  lastSession: FirebaseTimestamp;
  email: string;
  gender: Gender;
  status: ClientStatus;
  orgId: string;
  therapistId: string;
  createdAt: FirebaseTimestamp;
  totalSessions: number;
  id: string;
  role: string;
};

export enum ClientStatus {
  Active = 'active',
  Inactive = 'inactive',
  Archived = 'archived',
}

export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'prefer_not_to_say',
}
